/**
 * Campos de tradução de um cadastro: o texto original em português e um bloco por idioma.
 *
 * Usado dentro do ModalTraducoes e direto em formulários que já são um modal (ex.: edição do
 * campo personalizado pela lista), onde abrir outro modal por cima disputaria o foco.
 *
 * `campos`: [{ campo: 'nome', rotulo: 'Nome', original: '...', multilinha?, ajuda? }]
 * `traducoes`: { 'en-US': { nome: '...' }, es: {...} }
 */
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import { IDIOMAS_TRADUCAO } from "./traducoes";

const CamposTraducao = ({ campos, traducoes, onChange }) => (
    <>
        <p className="text-muted small">
            Exibidas para quem usa o sistema nesses idiomas; campo em branco mostra o texto em português.
            As regras e configurações continuam usando o texto em português.
        </p>

        <div className="border rounded p-2 mb-3 bg-light small">
            <div className="fw-bold mb-1">Português (original)</div>
            {campos.map(({ campo, rotulo, original }) => (
                <div key={campo} style={{ whiteSpace: 'pre-line' }}>
                    <strong>{rotulo}:</strong> {original || '—'}
                </div>
            ))}
        </div>

        {IDIOMAS_TRADUCAO.map(({ codigo, rotulo }) => (
            <div key={codigo} className="mb-3">
                <h6 className="fw-bold">{rotulo}</h6>
                {campos.map(({ campo, rotulo: rotuloCampo, multilinha, ajuda }) => (
                    <Form.Group key={campo} className="mb-2">
                        <Form.Label>{rotuloCampo}</Form.Label>
                        <Form.Control
                            as={multilinha ? 'textarea' : 'input'}
                            rows={multilinha ? 3 : undefined}
                            value={traducoes?.[codigo]?.[campo] || ''}
                            onChange={(e) => onChange(codigo, campo, e.target.value)}
                        />
                        {ajuda && <Form.Text className="text-muted">{ajuda}</Form.Text>}
                    </Form.Group>
                ))}
            </div>
        ))}
    </>
);

CamposTraducao.propTypes = {
    campos: PropTypes.arrayOf(PropTypes.shape({
        campo: PropTypes.string.isRequired,
        rotulo: PropTypes.string.isRequired,
        original: PropTypes.string,
        multilinha: PropTypes.bool,
        ajuda: PropTypes.string,
    })).isRequired,
    traducoes: PropTypes.object,
    onChange: PropTypes.func.isRequired,
};

export default CamposTraducao;
